<section class="wrapper">
  <div class="box-container">
    <label class="box-label">Nome</label>
    <span class="box-info destaque">Avalista {{ numero }}</span>

    <div class="horizontal-grid">
      <div class="item">
        <label class="box-label">CPF</label>
        <span class="box-info">{{ avalista.cpf | cpf }}</span>
      </div>
      <div class="item">
        <label class="box-label">Data de nascimento</label>
        <span class="box-info">{{ avalista.dtNascimento | date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="item">
        <label class="box-label">Classe Profissional</label>
        <span class="box-info">{{ getClasseProfissional(avalista.dadosProfissionais.classeProfissional.id)?.descricao }}</span>
      </div>

      <div class="item">
        <label class="box-label">Renda</label>
        <span class="box-info">{{ avalista.dadosProfissionais?.salario | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>

      <div class="item">
        <label class="box-label">Relação com o cliente</label>
        <span class="box-info">{{ grausParentescos[avalista.grauParentesco] }}</span>
      </div>

    </div>
  </div>

  <div class="actions">
    <a (click)="edit.emit(avalista)">alterar</a> <a (click)="remove.emit(avalista)">remover</a>
  </div>
</section>
